const LogoutOnAuthErrors = ['invalid_grant', 'interaction_required', 'no_tokens_found'];

export default LogoutOnAuthErrors;
